import React, { memo, useRef, useEffect } from 'react';
import { areEqual, FixedSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import AutoSizer from 'react-virtualized-auto-sizer';
import memoize from 'memoize-one';

import { CFlatListSection } from './styles';
import { isItemLoaded, loadMoreItems } from './loadMoreItems';
import { Text } from '@/styles/reactnative';
import { COLORS } from '@app/constants';
// import NoData from './NoData'
import CNoDataFound from '../CNoDataFound';
import { useWindowDimensions } from '@app/hooks';
import { useIsMobile } from '@utils/CalVW.tsx';

// createItemData 함수는 제거하거나 사용하지 않습니다.

const CFlatList = ({
  data,
  renderItem,
  itemSize,
  noDataTitle,
  noData = null,
}: any) => {
  const isMobile = useIsMobile();
  const { width } = useWindowDimensions();

  useEffect(() => {
    if (Array.isArray(data)) {
      console.log('데이터가 배열입니다.');
      if (data.length > 0) {
        console.log('첫 번째 항목:', data[0]);
      } else {
        console.log('배열이 비어있습니다.');
      }
    } else {
      console.log('데이터가 배열이 아닙니다!');
    }
  }, [data]);

  const getItemHeight = (item) => {
    if (isNaN(item)) item = 50;

    if (width >= 500 && width <= 600) {
      return item + 20;
    } else if (width >= 400 && width < 500) {
      return item + 5;
    } else if (width >= 250 && width < 400) {
      return item - 5;
    } else {
      return item ? item : 50;
    }
  };

  const infiniteLoaderRef = useRef(null);
  const Row = memo(({ data, index, style }: any) => {
    console.log('Row 렌더링:', index, data?.[index]);
    return (
      <div style={{ ...style }}>
        {!isItemLoaded(index) ? (
          <Text style={{ color: COLORS.grayWhite }}>Loading....</Text>
        ) : (
          renderItem(data[index], index)
        )}
      </div>
    );
  }, areEqual);

  return (
    <CFlatListSection>
      {data?.length ? (
        <AutoSizer>
          {({ height, width }) => {
            console.log('AutoSizer 렌더링:', height, width);
            return (
              <InfiniteLoader
                isItemLoaded={isItemLoaded}
                itemCount={data.length}
                loadMoreItems={loadMoreItems}
                ref={infiniteLoaderRef}
              >
                {({ onItemsRendered, ref }) => (
                  <List
                    itemData={data}
                    className="List"
                    height={height}
                    itemCount={data.length}
                    itemSize={getItemHeight(itemSize)}
                    width={width}
                    onItemsRendered={onItemsRendered}
                    ref={ref}
                    itemKey={(index, items: any) =>
                      items?.[index]?.ep_id || items?.[index]?.id || index
                    }
                    style={{
                      overscrollBehavior: 'none' /* iOS 외부 스크롤 차단 */,
                      WebkitOverflowScrolling:
                        'touch' /* 부드러운 스크롤 유지 */,
                    }}
                  >
                    {Row}
                  </List>
                )}
              </InfiniteLoader>
            );
          }}
        </AutoSizer>
      ) : noData ? (
        noData
      ) : (
        <CNoDataFound
          noDataTitle={noDataTitle}
          noDataContent={undefined}
          noDataSize={undefined}
          noDataHeight={undefined}
          lottieSize={undefined}
        />
      )}
    </CFlatListSection>
  );
};

export default React.memo(CFlatList);
